import { Skeleton } from "@mui/material";
import { Stack } from "@mui/system";

function Skeliton() {
    return <Stack spacing={1}>
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "23px",
                width: "100%",
            }}
        >
            <Skeleton
                variant="rounded"
                width={"50%"}
                height={35}
                animation="wave"
                style={{ marginRight: "23px" }}
            />

            <Skeleton
                variant="rounded"
                width={"50%"}
                height={35}
                animation="wave"
                style={{ marginRight: "23px" }}
            />

            <Skeleton
                variant="rounded"
                width={"50%"}
                height={35}
                animation="wave"
            />
        </div>

        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "23px",
                width: "100%",
            }}
        >
            <Skeleton
                variant="rounded"
                width={"50%"}
                height={300}
                animation="wave"
                style={{ marginRight: "23px" }}
            />

            <Skeleton
                variant="rounded"
                width={"50%"}
                height={300}
                animation="wave"
                style={{ marginRight: "23px" }}
            />

            <Skeleton
                variant="rounded"
                width={"50%"}
                height={300}
                animation="wave"
            />
        </div>

    </Stack>
}

export default Skeliton;